module.exports = __webpack_public_path__ + "static/media/logo-largo-color.5ed0e5f5.png";